import {all, fork} from "redux-saga/effects";
import {put, takeEvery} from "@redux-saga/core/effects";
import {
    deleteElement,
    deleteElementError,
    deleteElementSuccess,
    dogAction,
    dogActionError,
    dogActionSuccess,
    DogElement,
    getAllDogWithoutBox,
    getAllElement,
    getAllElementAdopted,
    getAllElementAdoptedError,
    getAllElementAdoptedSuccess,
    getAllElementDead,
    getAllElementDeadError,
    getAllElementDeadSuccess,
    getAllElementDogMuniNotPageable,
    getAllElementDogNotPageable,
    getAllElementError,
    getAllElementErrorDogMuniNotPageable,
    getAllElementErrorDogNotPageable,
    getAllElementErrorDogWithoutBox,
    GetAllElementPayloadDog,
    getAllElementReturned,
    getAllElementSuccess,
    getAllElementSuccessDogMuniNotPageable,
    getAllElementSuccessDogNotPageable,
    getAllSuccessDogWithoutBox,
    getListDog,
    getListDogErrorDog,
    getListDogSuccessDog, getReport, getReportError, getReportSuccess,
    getSingleDog,
    getSingleDogError,
    getSingleDogSuccess,
    saveElement,
    saveElementError,
    saveElementSuccess,
    updateElement,
    updateElementBoxDogs,
    updateElementBoxDogssError,
    updateElementBoxDogsSuccess,
    updateElementError,
    updateElementSuccess,
} from "../reducers/Dog/DogReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";

interface DogFilter {
    name: string | null,
    microchipCode: string | null,
    nameBox: string | null
    shedName: string | null,
    status: string | null,
    municipalityId: string | null,
    sex: string | null
    isSterilizied: string | null
}

function* getAllElementSaga() {
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloadDog>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({type: getAllElementError.type});
            return;
        }
        try {
            let response: CustomFetchResponse
            let filters: DogFilter = {
                name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? "",
                microchipCode: action.payload.filters?.find(filter => filter.id === "microchipCode")?.value as string ?? "",
                municipalityId: action.payload.filters?.find(filter => filter.id === "municipalityId")?.value as string ?? "",
                nameBox: action.payload.filters?.find(filter => filter.id === "box_name")?.value as string ?? "",
                shedName: action.payload.filters?.find(filter => filter.id === "box_shedName")?.value as string ?? "",
                sex: action.payload.filters?.find(filter => filter.id === "sex")?.value as string ?? "",
                isSterilizied: action.payload.filters?.find(filter => filter.id === "isSterilizied")?.value as string ?? null,
                status: "CATCHED"
            }

            let requestPayload = {
                ...action.payload.pageableDto,
                filters: filters
            }

            response = yield CustomFetch({
                method: "POST",
                url: apiPaths.filterDog, // Percorso API specifico per il filtro
                authenticated: true,
                data: requestPayload,
            });
            if (response.status === 200) {
                yield put({type: getAllElementSuccess.type, payload: response.data});
                // console.log('response box: ' , response.data );

            } else {
                yield put({type: getAllElementError.type});
            }
        }
        catch(error){
            console.error("Error in getAllElementSaga:", error);
            yield put({type: getAllElementError.type});
        }
    });
}

function* getActionDog() {
    yield takeEvery(dogAction.type, function* (action: PayloadAction<string>) {
        const url = `${apiPaths.dogAction}/${action.payload}`;
        let response: CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: url,
            authenticated: true,
        });

        if (response.status === 200) {
            yield put({
                type: dogActionSuccess.type,
                payload: response.data
            });
        } else {
            yield put({type: dogActionError.type});
        }
    })
}

function* getAllDogMuniNotPAgeable() {
    yield takeEvery(getAllElementDogMuniNotPageable.type, function* (action: PayloadAction<{ filters: string, callback: () => void }>) {
        try {
            const url = `${apiPaths.allDogWithMuniNotPageable}/${action.payload.filters}`;

            const response: CustomFetchResponse = yield CustomFetch({
                method: "GET",
                url: url,
                authenticated: true
            });

            if (response.status === 200) {
                yield put({
                    type: getAllElementSuccessDogMuniNotPageable.type,
                    payload: {data: response.data}
                });
                if (action.payload.callback) {
                    action.payload.callback();
                }
            } else {
                yield put({type: getAllElementErrorDogMuniNotPageable.type});
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: 'Error fetching dogs data',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    }
                });
            }
        } catch (error) {
            yield put({type: getAllElementErrorDogMuniNotPageable.type});
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Error fetching dogs data',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }
    });
}

function* getListDogSelected() {
    yield takeEvery(getListDog.type, function* (action: PayloadAction<{ filters: string, callback: () => void }>) {
        try {
            const url = `${apiPaths.filterDogList}`;

            const response: CustomFetchResponse = yield CustomFetch({
                method: "POST",
                url: url,
                authenticated: true,
                data: action.payload.filters
            });


            console.log(response.data)
            if (response.status === 200) {
                yield put({
                    type: getListDogSuccessDog.type,
                    payload: {data: response.data}
                });
                if (action.payload.callback) {
                    action.payload.callback();
                }
            } else {
                yield put({type: getListDogErrorDog.type});
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: 'Error fetching dogs data',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    }
                });
            }
        } catch (error) {
            yield put({type: getAllElementErrorDogMuniNotPageable.type});
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Error fetching dogs data',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }
    });
}


function* getAllElementDied() {
    yield takeEvery(getAllElementDead.type, function* (action: PayloadAction<GetAllElementPayloadDog>) {

        if (!action.payload || !action.payload.pageableDto) {
            yield put({type: getAllElementDeadError.type});
            return;
        }
        try {
            let response: CustomFetchResponse


                let filters: DogFilter = {
                    name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? "",
                    microchipCode: action.payload.filters?.find(filter => filter.id === "microchipCode")?.value as string ?? "",
                    nameBox: action.payload.filters?.find(filter => filter.id === "box_name")?.value as string ?? "",
                    municipalityId: action.payload.filters?.find(filter => filter.id === "municipalityId")?.value as string ?? "",
                    shedName: action.payload.filters?.find(filter => filter.id === "box_shedName")?.value as string ?? "",
                    sex: action.payload.filters?.find(filter => filter.id === "sex")?.value as string ?? "",
                    isSterilizied: action.payload.filters?.find(filter => filter.id === "isSterilizied")?.value as string ?? null,
                    status: "DIED"
                };

                let requestPayload = {
                    ...action.payload.pageableDto,
                    filters: filters
                }

                response = yield CustomFetch({
                    method: "POST",
                    url: apiPaths.filterDogDead, // Percorso API specifico per il filtro
                    authenticated: true,
                    data: requestPayload,
                });



            if (response.status === 200) {
                yield put({type: getAllElementDeadSuccess.type, payload: response.data});
                // console.log('response box: ' , response.data );

            } else {
                yield put({type: getAllElementDeadError.type});
            }
        } catch (error) {
            //  console.error("Error in getAllElementSaga:", error);
            yield put({type: getAllElementDeadError.type});
        }
    });
}

function* getAllElementAdopt() {
    yield takeEvery(getAllElementAdopted.type, function* (action: PayloadAction<GetAllElementPayloadDog>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({type: getAllElementDeadError.type});
            return;
        }

        try {
            let response: CustomFetchResponse
                //console.log(action.payload.filters)

                let filters: DogFilter = {
                    name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? "",
                    microchipCode: action.payload.filters?.find(filter => filter.id === "microchipCode")?.value as string ?? "",
                    nameBox: action.payload.filters?.find(filter => filter.id === "box_name")?.value as string ?? "",
                    municipalityId: action.payload.filters?.find(filter => filter.id === "municipalityId")?.value as string ?? "",
                    shedName: action.payload.filters?.find(filter => filter.id === "box_shedName")?.value as string ?? "",
                    sex: action.payload.filters?.find(filter => filter.id === "sex")?.value as string ?? "",
                    isSterilizied: action.payload.filters?.find(filter => filter.id === "isSterilizied")?.value as string ?? null,
                    status: "ADOPTED"

                };
                let requestPayload = {
                    ...action.payload.pageableDto,
                    filters: filters
                }

                response = yield CustomFetch({
                    method: "POST",
                    url: apiPaths.filterDogAdopted, // Percorso API specifico per il filtro
                    authenticated: true,
                    data: requestPayload,
                });
                if (response.status === 200) {
                    yield put({type: getAllElementAdoptedSuccess.type, payload: response.data});
                    // console.log('response box: ' , response.data );

                } else {
                    yield put({type: getAllElementAdoptedError.type});
                }
            } catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({type: getAllElementAdoptedError.type});
        }
    });
}

function* getAllElementReturn() {
    yield takeEvery(getAllElementReturned.type, function* (action: PayloadAction<GetAllElementPayloadDog>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({type: getAllElementDeadError.type});
            return;
        }

        try {
            let response: CustomFetchResponse


                //console.log(action.payload.filters)

                let filters: DogFilter = {
                    name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? "",
                    microchipCode: action.payload.filters?.find(filter => filter.id === "microchipCode")?.value as string ?? "",
                    nameBox: action.payload.filters?.find(filter => filter.id === "box_name")?.value as string ?? "",
                    municipalityId: action.payload.filters?.find(filter => filter.id === "municipalityId")?.value as string ?? "",
                    shedName: action.payload.filters?.find(filter => filter.id === "box_shedName")?.value as string ?? "",
                    sex: action.payload.filters?.find(filter => filter.id === "sex")?.value as string ?? "",
                    isSterilizied: action.payload.filters?.find(filter => filter.id === "isSterilizied")?.value as string ?? null,
                    status: "RETURNED"

                };
                let requestPayload = {
                    ...action.payload.pageableDto,
                    filters: filters
                }

                response = yield CustomFetch({
                    method: "POST",
                    url: apiPaths.filterDogReturned, // Percorso API specifico per il filtro
                    authenticated: true,
                    data: requestPayload,
                });
                if (response.status === 200) {
                    yield put({type: getAllElementAdoptedSuccess.type, payload: response.data});

                } else {
                    yield put({type: getAllElementAdoptedError.type});
                }
            } catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({type: getAllElementAdoptedError.type});
        }
    });
}

function* saveElementSaga() {
    yield takeEvery(saveElement.type, function* (action: PayloadAction<{ data: DogElement, callback: () => void }>) {

        const dataCreate = {
            name: action.payload.data.name,
            microchipCode: action.payload.data.microchipCode,
            municipalityId: action.payload.data.municipalityId,
            sex: action.payload.data.sex,
            catchingHealthStatus: action.payload.data.catchingHealthStatus,
            coatColor: action.payload.data.coatColor,
            dogStatusType: action.payload.data.dogStatusType,
            race: action.payload.data.race,
            isSterilizied: action.payload.data.isSterilizied,
            sterilizationDate: action.payload.data.sterilizationDate || null,
            catchingDate: action.payload.data.catchingDate,
            photoProfil: action.payload.data.photoProfil,
            box: action.payload.data.box?._id || null,
            dogHairLength: action.payload.data.dogHairLength,
            treatments: action.payload.data.treatments || [],
            multimedias: action.payload.data.multimedias || [],
            bornDate: action.payload.data.bornDate,
            diedDate: action.payload.data.diedDate || null,
            returnedDate: action.payload.data.returnedDate || null,
            sizeDog: action.payload.data.sizeDog || null
        };

        let response: CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.saveDog,
            authenticated: true,
            data: dataCreate
        })

        if (response.status === 200) {
            yield put({type: saveElementSuccess.type, payload: response.data})

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element added successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })

            if (action.payload.callback) {
                action.payload.callback();
            }

        } else {
            yield put({type: saveElementError.type})

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Error adding element',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }
    })
}


function* updateElementSaga() {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<{ data: DogElement, callback: () => void }>) {
        const url = `${apiPaths.updateDog}/${action.payload.data._id}`;

        const dataUpdate = {
            name: action.payload.data.name,
            microchipCode: action.payload.data.microchipCode,
            municipalityId: action.payload.data.municipalityId,
            sex: action.payload.data.sex,
            catchingHealthStatus: action.payload.data.catchingHealthStatus,
            coatColor: action.payload.data.coatColor,
            catchingDate: action.payload.data.catchingDate,
            race: action.payload.data.race,
            isSterilizied: action.payload.data.isSterilizied,
            sterilizationDate: action.payload.data.sterilizationDate,
            photoProfil: action.payload.data.photoProfil,
            box: action.payload.data.box?._id || null,
            treatments: action.payload.data.treatments || [],
            multimedias: action.payload.data.multimedias || [],
            bornDate: action.payload.data.bornDate,
            dogHairLength: action.payload.data.dogHairLength,
            diedDate: action.payload.data.diedDate || null,
            adoptionDate: action.payload.data.adoptionDate || null,
            returnedDate: action.payload.data.returnedDate || null,
            sizeDog: action.payload.data.sizeDog || null,
            dogStatusType: action.payload.data.dogStatusType,
        };

        let response: CustomFetchResponse = yield CustomFetch({
            method: "PUT",
            url: url,
            authenticated: true,
            data: dataUpdate
        })

        if (response.status === 200) {
            yield put({
                type: updateElementSuccess.type,
                payload: response.data
            })

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element updated successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })

            if (action.payload.callback) {
                action.payload.callback();
            }
        } else {
            yield put({
                type: updateElementError.type,
            })

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element not updated',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }
    });
}

function* getAllElementNotPageableSaga() {
    yield takeEvery(getAllElementDogNotPageable.type, function* (action: PayloadAction<DogElement>) {
        try {
            const response: CustomFetchResponse = yield CustomFetch({
                method: "GET",
                url: apiPaths.allDogWithoutPaginable,
                authenticated: true,
            });
            if (response?.status === 200 && response.data) {
                yield put({
                    type: getAllElementSuccessDogNotPageable.type,
                    payload: response.data,
                });
            } else {
                yield put({type: getAllElementErrorDogNotPageable.type});
            }
        } catch (error) {
            // Gestione errori generici
            console.error("Errore durante il fetch degli elementi:", error);
            yield put({type: getAllElementErrorDogNotPageable.type});
        }
    });
}

function* showDogWithoutBox() {
    yield takeEvery(getAllDogWithoutBox.type, function* (action: PayloadAction<DogElement>) {
        let response: CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: apiPaths.showDogWithoutBox,
            authenticated: true
        })

        if (response.status === 200) {
            yield put({
                type: getAllSuccessDogWithoutBox.type,
                payload: response.data
            })
        } else {
            yield put({
                type: getAllElementErrorDogWithoutBox.type,
            })
        }
    })
}

function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<{ id: string, callback: () => void }>) {

        const url = `${apiPaths.deleteDog}/${action.payload.id}`
        let response: CustomFetchResponse = yield CustomFetch({
            method: "DELETE",
            url: url,
            authenticated: true,
            data: action.payload
        })

        if (response.status === 200) {

            action.payload.callback()

            yield put({type: deleteElementSuccess.type, payload: response.data.content})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element deleted successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
        } else {
            yield put({type: deleteElementError.type})
        }
    })
}

function* findSingleResult() {
    yield takeEvery(getSingleDog.type, function* (action: PayloadAction<DogElement>) {
        try {
            const response: CustomFetchResponse = yield CustomFetch({
                method: "GET",
                url: `${apiPaths.singleDog}/${action.payload}`,
                authenticated: true,
            });
            if (response?.status === 200 && response.data) {
                yield put({
                    type: getSingleDogSuccess.type,
                    payload: response.data,
                });
            } else {
                yield put({type: getSingleDogError.type});
            }
        } catch (error) {
            // Gestione errori generici
            console.error("Errore durante il fetch del singolo elemento:", error);
            yield put({type: getSingleDogError.type});
        }
    });

}

    function* getReports() {
        yield takeEvery(getReport.type, function* (action: PayloadAction<DogElement>) {
            try {
                const response: CustomFetchResponse = yield CustomFetch({
                    method: "GET",
                    url: `${apiPaths.dogReport}`,
                    authenticated: true,
                });
                if (response?.status === 200 && response.data) {
                    yield put({
                        type: getReportSuccess.type,
                        payload: response.data,
                    });
                } else {
                    yield put({type:  getReportError.type});
                }
            } catch (error) {
                // Gestione errori generici
                console.error("Errore durante il fetch del singolo elemento:", error);
                yield put({type: getReportError.type});
            }
        });
    }

function* changeBox() {
    yield takeEvery(updateElementBoxDogs.type, function* (action: PayloadAction<{ idBox: string; dogIds: string[], callback: () => void }>) {
        const {idBox, dogIds} = action.payload; // Ottieni i dati dal payload dell'azione

        const url = `${apiPaths.changeDogBox}`; // Percorso API per aggiornare i cani

        const dataUpdate = {
            idBox: idBox, // ID del box di destinazione
            dogIds: dogIds, // Lista degli ID dei cani da spostare
        };

        try {
            // Effettua la chiamata API per aggiornare il box dei cani
            let response: CustomFetchResponse = yield CustomFetch({
                method: "PUT",
                url: url,
                authenticated: true,
                data: dataUpdate,
            });

            if (response.status === 200) {
                action.payload.callback()

                // Se l'aggiornamento ha successo, dispatcha l'azione di successo
                yield put({
                    type: updateElementBoxDogsSuccess.type,
                    payload: {
                        idBox: idBox,
                        dogIds: dogIds,
                    },
                });
                // Mostra una notifica di successo
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: "Dogs successfully moved to the selected box.",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                    },
                });

                //  getAllElementSaga()
            } else {
                // In caso di errore, dispatcha l'azione di errore
                console.error(response.data);
                yield put({
                    type: updateElementBoxDogssError.type,
                });

                // Mostra una notifica di errore
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: "Failed to move dogs. Please try again.",
                        variant: "alert",
                        alert: {
                            color: "error",
                        },
                    },
                });
            }
        } catch (error) {
            // Gestione degli errori generali (ad esempio, errori di rete)
            console.error("Error while updating dog box:", error);
            yield put({
                type: updateElementBoxDogssError.type,
            });

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: "An unexpected error occurred. Please try again later.",
                    variant: "alert",
                    alert: {
                        color: "error",
                    },
                },
            });
        }
    });
}


export default function* DogSaga() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(getAllElementAdopt),
            fork(getAllElementDied),
            fork(deleteElementSaga),
            fork(getAllElementNotPageableSaga),
            fork(getAllElementReturn),
            fork(showDogWithoutBox),
            fork(changeBox),
            fork(getAllDogMuniNotPAgeable),
            fork(getListDogSelected),
            fork(getActionDog),
            fork(findSingleResult),
            fork(getReports)
        ],
    )
}